import { Card } from "@/_old/components/ui/card";
import { CarouselInsightsItem } from "@/core/components/layout/carousel-insights/components/carousel-insights-item";
import { useEffect, useState } from "react";
import { InsightsCardsConsumptionProps } from "./insights-cards-consumption.types";
function InsightsCardsConsumption({
  tag,
  description,
  content,
  buttonText,
  icon,
  subtitle,
  body,
  type,
  emptyContent,
  onClick,
  hasSubtitleDefaultColor = false,
  carousel = false,
}: InsightsCardsConsumptionProps) {
  const [color, setColor] = useState<{
    background: string;
    text: string;
    subtitle: string;
    iconBackground: string;
    iconText: string;
  } | null>(null);

  const colors = {
    warning: {
      background: "orange-500",
      text: "white",
      subtitle: "sky-600",
      iconBackground: "orange-50",
      iconText: "orange-500",
    },
    danger: {
      background: "destructive",
      text: "white",
      subtitle: hasSubtitleDefaultColor ? "sky-600" : "destructive",
      iconBackground: "red-100",
      iconText: "destructive",
    },
    default: {
      background: "secondary",
      text: "secondary-foreground",
      subtitle: "sky-600",
      iconBackground: "blue-100",
      iconText: "blue-800",
    },
    good: {
      background: "#16A34A",
      text: "white",
      subtitle: "sky-600",
      iconBackground: "success-50",
      iconText: "success-500",
    },
  };

  useEffect(() => {
    const color = colors[type];

    setColor(color);
  }, [type]);

  if (!color) {
    return null;
  }

  return (
    <>
      {carousel ? (
        <CarouselInsightsItem
          icon={icon}
          tag={tag}
          content={content}
          emptyContent={emptyContent}
          buttonText={buttonText}
          color={color}
          onClick={onClick}
        />
      ) : (
        <Card className="p-4 border border-[#e2e8f0] rounded-[16px] flex flex-col justify-between shadow-none">
          <div className="flex flex-col">
            <div className="flex justify-between items-start mb-4">
              <div className="text-muted-foreground">{icon}</div>
              <span
                className={`text-[12px] font-normal px-3 rounded-full bg-${color.background} text-${color.text}`}
                style={{
                  backgroundColor: color.background.includes("#")
                    ? color.background
                    : undefined,
                  color: color.text.includes("#") ? color.text : undefined,
                }}
              >
                {tag}
              </span>
            </div>

            {!emptyContent && content ? (
              <div className="mb-2 font-normal">{content}</div>
            ) : null}

            {emptyContent && <p className="mb-2 font-normal">{emptyContent}</p>}

            {!emptyContent && subtitle ? (
              <p
                className={`mb-3 font-normal text-[14px] text-${color.subtitle}`}
              >
                {subtitle}
              </p>
            ) : null}

            {!emptyContent && body ? (
              <div className="my-4 font-normal">{body}</div>
            ) : null}

            <p className="text-muted-foreground font-normal text-[14px] mb-4">
              {description}
            </p>
          </div>

          <button
            onClick={onClick}
            className="w-full py-2 text-center border border-[#e2e8f0] rounded-md text-[#0f172a] text-[14px] font-medium hover:bg-[#f8fafc] transition-colors"
          >
            {buttonText}
          </button>
        </Card>
      )}
    </>
  );
}

export { InsightsCardsConsumption };
